import { useContext, createContext, useEffect } from "react";
import './Tab.css'
import { TabContentProp, TabItemProp, TabPanelProp, TabsProp } from "./Tab";

const TabsContext = createContext(null);
const Tabs = (props: TabsProp) => {
    return (
        <div key={props.id} className="pcss3t pcss3t-effect-scale pcss3t-theme-1 pcss3t-height-auto">
            <TabsContext.Provider value={{ ...props }}>
                {props.children}
            </TabsContext.Provider>
        </div>
    )
}
export default Tabs;

export const TabItem = (props: TabItemProp) => {
    const { defaultTab, onTabChange } = useContext(TabsContext);
    let sClassNameItem = props.isSub ? ("cTablabelSub_" + props.idHeadSub) : "cTablabel";
    let sClassPanel = props.isSub ? ("tab-content-sub-" + props.idHeadSub) : "tab-content";
    let sClassTabPanel = props.isSub ? "TabPanel_Sub_" : "TabPanel_";

    const onClickTabItem = (tabId) => {
        let cTablabel = document.getElementsByClassName(sClassNameItem);
        for (const element of cTablabel) {
            const slide = element as HTMLElement;
            if (slide.id === tabId) {
                slide.style.marginBottom = "0";
                slide.style.paddingBottom = "5px";
                slide.style.opacity = "1";
                slide.style.borderBottomRightRadius = "0px";
                slide.style.borderBottomLeftRadius = "0px";
                slide.style.color = "#ffffff";
                slide.style.cursor = "default";
                slide.style.boxShadow = "rgba(0, 10, 74, 0.23) 0px 5px 2px 0px inset";
                slide.style.zIndex = "2";
                slide.style.background = "rgb(188,123,41)";
                slide.style.background = props.sBackgroundTabActive ?? "linear-gradient(180deg, rgba(188,123,41,1) 33%, rgba(217,180,134,1) 71%, rgba(233,211,184,1) 87%, rgba(255,255,255,1) 100%)";
                slide.style.minWidth = '100px';
                slide.style.textAlign = 'center';
            } 
            else if (props.isDisabled === true)
            {
                slide.style.margin = "2px 5px 1.8px 2px";
                slide.style.borderRadius = "5px";
                slide.style.boxShadow = "rgba(169, 182, 187, 0.28) 0px 10px 36px 0px, rrgb(50 25 179 / 40%) 0px 0px 0px 1px";
                slide.style.color = "#ffffff";
                slide.style.paddingBottom = "0";
                slide.style.cursor = "pointer";
                slide.style.zIndex = "1";
                slide.style.background = "rgb(173 173 173)";
                slide.style.minWidth = '100px';
                slide.style.textAlign = 'center';
            }
            else 
            {
                slide.style.margin = "2px 5px 1.8px 2px";
                slide.style.borderRadius = "5px";
                slide.style.boxShadow = "rgba(169, 182, 187, 0.28) 0px 10px 36px 0px, rrgb(50 25 179 / 40%) 0px 0px 0px 1px";
                slide.style.color = "#ffffff";
                slide.style.paddingBottom = "0";
                slide.style.cursor = "pointer";
                slide.style.zIndex = "1";
                slide.style.background = props.sBackgroundTab ?? "#995b1a"; //#6e130d
                slide.style.minWidth = '100px';
                slide.style.textAlign = 'center';
            }
        }
        let tabcontent = document.getElementsByClassName(sClassPanel);
        for (const element of tabcontent) {
            const slide = element as HTMLElement;
            slide.style.display = "none";
            slide.style.borderBottom = '10%';
        }
        
        let tset = document.getElementById(sClassTabPanel + tabId);
        if (tset) {
            tset.style.display = "block";
            tset.style.zIndex = "1";
            tset.style.opacity = "1";
            tset.style.top = "0";
            tset.style.left = "0";
            tset.style.webkitTransform = "scale(1,1)";
            // tset.style.webkitTransform = "rotate(0deg)";
            tset.style.borderBottom = '10%';
        }
        if (onTabChange) {
            onTabChange(tabId);
        }
    }

    useEffect(() => {
        if (defaultTab) {
            onClickTabItem(defaultTab);
        }
    }, [defaultTab])

    return (
        <>
            <label key={props.id} className={sClassNameItem} id={props.id} onClick={() => {
                if(props.isDisabled !== true) onClickTabItem(props.id)
            }}>{props.children}</label>
        </>
    )
}

export const TabContent = (prop: TabContentProp) => {
    return (
        <ul key={prop.id} >
            {prop.children}
        </ul>
    )
}

export const TabPanel = (prop: TabPanelProp) => {
    let sClass = prop.isSub ? ("tab-content-sub-"+ prop.idHeadSub) : "tab-content";
    let sClassTabPanel = prop.isSub ? "TabPanel_Sub_" : "TabPanel_";
    return (
        <li className={sClass} id={sClassTabPanel + prop.id} key={prop.id} style={{...prop.style}}>
            {prop.children}
        </li>
    )
}
